<div >
  <button (click)="desativaCoordenada()" id="btnDesativaCoordenada" hidden=true></button>
  <!-- Dados Entregas -->
  <div class="pb-3" class="divisor-secao" *ngIf="!roteiroCrossdocking">
    <span class="tit-principal">Entregas ({{ dados.realizadas }}/{{ dados.QtdeEntregas }})</span>

    <div class="d-flex justify-content-between mt-3">
      <div class="d-flex">
        <img src="assets/img/status_odometro_inicio.svg" class="me-2" style="position: relative; z-index: 2;left: -1px;">     
        <span class="barra-primeira-entrega"></span>
        <div class="d-flex flex-column">
          <span class="titulo">1ª Entrega</span>
          <span class="sub-titulo" >{{ dados.primeira_entrega != ""? (dados.primeira_entrega | date : 'dd/MM/yyyy') : '--/--/---' }} às {{ dados.primeira_entrega != ""? (dados.primeira_entrega | date : 'HH:mm') : '--:--' }}  </span>
        </div>
      </div>
  
      <div class="d-flex">      
        <div class="d-flex flex-column align-items-end">
          <span class="titulo">Entrega final</span>
          <span class="sub-titulo"> {{ dados.ultima_entrega != "" && dados.realizadas == dados.QtdeEntregas?? 1? (dados.ultima_entrega | date : 'dd/MM/yyyy') : '--/--/---' }} às {{ dados.ultima_entrega != "" && dados.realizadas == dados.QtdeEntregas? (dados.ultima_entrega | date : 'HH:mm') : '--:--' }}</span>
        </div>
        <img src="assets/img/status_odometro_final.svg" class="ms-2" style="margin-right: -9px;">    
        <span class="barra-ultima-entrega"></span>   
      </div>
    </div>
  
    <div class="w-100 d-flex flex-column align-items-center grid-progress">
      <progress
      max="100"
      class="w-100"
      [value]="(dados.realizadas * 100) / (dados.QtdeEntregas == 0 ? 1 : dados.QtdeEntregas)"
      [ngClass]="{
        'progress-bar-incomplete': (dados.realizadas * 100) / (dados.QtdeEntregas == 0 ? 1 : dados.QtdeEntregas) < 100,
        'progress-bar-complete': (dados.realizadas * 100) / (dados.QtdeEntregas == 0 ? 1 : dados.QtdeEntregas) === 100
      }"
    ></progress>
    
      <span class="tit-principal">{{ ((dados.realizadas * 100) / (dados.QtdeEntregas == 0 ? 1 : dados.QtdeEntregas)).toFixed(1) }}%</span>
      <span class="dados-info-ult-entrega" *ngIf='dados.realizadas != dados.QtdeEntregas'>
        Última entrega feita  
        <span class="dados-date-ultima-entrega">{{ dados.ultima_entrega != ""? (dados.ultima_entrega | date : 'dd/MM/yyyy') : '--/--/---' }}  </span>
        <span class="dados-info-ult-entrega"> às  </span>
        <span class="dados-date-ultima-entrega">{{ dados.ultima_entrega != ""? (dados.ultima_entrega | date : 'HH:mm') : '--:--' }}</span>
      
      </span>
    </div>
  </div>

  <!-- Area de distancia dos ajusntes -->
  <div class=" mt-3 mb-4 divisor-secao" *ngIf="distanciasPercorridaMotorAjud.length">
    <span class="tit-principal d-flex pt-3 pb-4">Distância Percorridas</span>
    <div *ngFor="let item of distanciasPercorridaMotorAjud; let i = index" class="mb-4">
      <app-box-dist-entrega [indice]="i + 1" [dados]="distanciasPercorridaMotorAjud[i]"></app-box-dist-entrega>
    </div>
  </div>

  <div class="d-flex justify-content-between align-items-end mt-3 mb-4">
    <span class="tit-principal">Distância</span>
    <div class="d-flex">
      <div (click)="consultarEditarOdometro()" class="me-4 hide-on-mobile" *ngIf="kmOdometroInicio != null && kmOdometroFinal != null" ><app-texto-link titulo="Editar odômetro" icone='icon-lapis-green' ></app-texto-link></div>
      <app-texto-link titulo="Atualizar mapa" icone='coordenada_mapa' (click)="atualizaCoordenadas()"></app-texto-link>
    </div>
  </div>
 

  <div  class="w-100 d-flex flex-column align-items-center grid-progress" *ngIf="!solicitaOdometro;else odometro">

    <div class="d-flex justify-content-between mt-3 w-100">     
        <img src="assets/img/ultima_entrega_dist.svg" class="me-2" >   
        <div>
          <img [src]="imgUltimaEntrega" class="ms-2" style="position: relative"  [ngStyle]="{'left.px': descricaoUltimaEntrega === 'Última entrega' ? 19 :  descricaoUltimaEntrega == 'Distribuidora'? 19 : 13}"
          [ngClass]="{'size-icone' : descricaoUltimaEntrega == 'Casa motorista'}"
          >  <span class="barra-ultima-entrega-motor" *ngIf="descricaoUltimaEntrega == 'Casa motorista'"></span> 
        </div>
         
    </div>
   

    <progress #progressBar max="100" class="w-100 progress-bar-distancia" [value]="this.distanciaPercorridaPorcentagem > 100? graphicService.distanciaTotalPlanejada * 100 / graphicService.distanciaTotalRealizada : 100" >  
    </progress>

    <div class="d-flex align-items-center w-100 icon-container" style="position: relative; top: -12px; left: 6px;">
      <ng-container *ngFor="let icon of listaKmPercorrida">
        <span class="icon-dist-percorrida"></span>
        <span class="icon-bd-percorrida"></span>
      </ng-container>
    </div>
       

    <div class="d-flex justify-content-between mt-3 w-100 align-items-center">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center">
          <span class="km-percorrida me-1"></span>
          <span class="info-ultima-entrega me-3"> Dist. planejada</span>
          <span class="info-km"> {{ graphicService.distanciaTotalPlanejada? graphicService.distanciaTotalPlanejada.toFixed(1) : 0 }}<span class="info-ultima-entrega me-3">Km</span></span>

        </div>
        <div class="d-flex align-items-center">
          <span class="icon-dist-percorrida" ></span>
          <span class="icon-bd-percorrida"></span>
          <span class="icon-dist-percorrida me-1" ></span>
          <span class="info-ultima-entrega me-3"> Dist. percorrida</span>
          <span class="info-km" style="margin-left: -3px;"> {{ graphicService.distanciaTotalRealizada.toFixed(1) ?? 0 }}<span class="info-ultima-entrega me-2">Km</span></span>
          <span class='info-porcetagem' *ngIf="graphicService.distanciaTotalRealizada > 0"
            [ngClass]="{
              'alert-km-percorrida': graphicService.distanciaTotalRealizada > 120, 
              'danger-km-percorrida': graphicService.distanciaTotalRealizada > 150             
            }"
            >({{ distanciaPercorridaPorcentagem.toFixed(1) }}%)</span>
        

        </div>
       
      </div>

      <app-status-roteiro
        *ngIf="roteiroCrossdocking ? dados.IdRoteiroSituacao === 1 : dados.realizadas === 0"
        mensagem="Não iniciado"
        color="#CFD8DC"
        caminho="assets/img/icons/icon-status-aberto.svg">
      </app-status-roteiro>

      <app-status-roteiro
        *ngIf="roteiroCrossdocking ? dados.IdRoteiroSituacao !== 1 : dados.realizadas === dados.QtdeEntregas"
        mensagem="Finalizada"
        color="#7FF3B9"
        caminho="assets/img/icons/icon-status-finalizado.svg">
      </app-status-roteiro>
    </div>

  
    <div class="d-flex justify-content-center mt-3">
      <app-botao-primario titulo="Atualizar km percorrida"  (onPress)="atualizaKmPercorrida()" imagemBtn="assets/img/icons/km-percorrida.svg" ></app-botao-primario>
    </div>
  </div>

  <!-- Informações Odometro -->
  <ng-template #odometro >
      <app-dual-info-component 
        tituloPrincipal="Distância planejada"
        [infoPrincipal]="graphicService.distanciaTotalPlanejada? graphicService.distanciaTotalPlanejada.toFixed(1) + ' Km' : '0 Km'" 
        [tituloSecundario]="tituloDistancia"
        [infoSecundario]="kmOdometroInicio == null || kmOdometroFinal == null? graphicService.distanciaTotalRealizada.toFixed(1) + ' Km' : (kmOdometroFinal - kmOdometroInicio).toFixed(1) + ' Km'"
      >

      <div class="d-flex justify-content-center mt-3 align-items-baseline">
         <img [src]="imgUltimaEntrega" alt="icone ultima entrega" class="me-1" height="16px">
         <span class="info-ultima-entrega me-1">Ponto Final do Roteiro</span>
         <span class="titulo">{{ descricaoUltimaEntrega }}</span>
      </div>
    
     </app-dual-info-component>

      <div class="d-flex justify-content-between align-items-center mt-3 container-odometro-status">
        <div class="d-flex">
          <img src='assets/img/odometro.svg' class="me-2">     
          <div class="d-flex flex-column">
              <span class="titulo">Odômetro inicial</span>
              <div class="d-flex">                
                <span class="sub-titulo" >{{ kmOdometroInicio != null ? kmOdometroInicio.toFixed(1) : '---'}} Km</span>
              </div>                                 
          </div>
        </div>

        <div>
          <app-status-roteiro *ngIf="kmOdometroInicio == null && kmOdometroFinal == null" mensagem="Não iniciado" color="#CFD8DC" caminho="assets/img/icons/icon-status-aberto.svg"></app-status-roteiro>
          <app-status-roteiro *ngIf="kmOdometroInicio != null && kmOdometroFinal == null" mensagem="Em rota" color="#81D4FA" caminho='assets/img/icons/icon-status-iniciado.svg'></app-status-roteiro>
          <app-status-roteiro *ngIf="kmOdometroInicio != null && kmOdometroFinal != null" mensagem="Finalizada" color="#7FF3B9" caminho='assets/img/icons/icon-status-finalizado.svg'></app-status-roteiro>
        </div>
    
        <div class="d-flex">      
          <div class="d-flex flex-column align-items-end">
            <span class="titulo">Odômetro final</span>
            <div class="d-flex">
              <span class="sub-titulo">{{ kmOdometroFinal != null ? kmOdometroFinal.toFixed(1) : '---'}} Km</span> 
            </div>           
          </div>
          <img src='assets/img/odometro.svg' class="ms-2">    
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3 hide-on-mobile" *ngIf="kmOdometroInicio != null ">
        <app-botao-primario 
          titulo="Ver fotos dos odômetros"  
          (onPress)="alternarModalOdometro()" 
          imagemBtn="assets/img/icons/dados_recebedor.svg"  
          title="Ver fotos dos odômetros" 
          >
       </app-botao-primario>
      </div>

      <button [hidden]="true" id="btnDownloadCompOdometro" (click)="downloadFotosOdometros()" ></button>
  </ng-template>


  <button [hidden]="true" id="atualizaIconeKmPercorrida" (click)="atualizaIconeKmPercorrida()"></button>
</div>


<div *ngIf="showModalOdometro && kmOdometroInicio != null">
  <div class="modal-confirm" style="z-index: 1230;">
    <div class="modal-conteudo">
      <div class="header-modal">
        <span>Dados ôdometro</span>
        <img (click)="alternarModalOdometro()" style="cursor: pointer;" src="assets/img/icons/close-white.svg">
      </div>
      <!-- Indicador de loading -->
      <div *ngIf="loadingFotoOdo" class="content-loading">
        <div class="box-loading">
          <img src='assets/img/loading.gif' alt="Carregando..."> 
          <p>Carregando informações...</p>
        </div>
      </div>
      <div *ngIf="!loadingFotoOdo">
        <div class="content-modal">
          <div class="box-distancia" *ngIf="kmOdometroFinal != null && !modoEdicaoOdometro">
            <span class="text-distancia  tit-principal">Distância: {{distanciaOdometro}} km</span>
          </div>
          
          <div style="display: flex; gap: 20px;">
            <div class="d-flex flex-column align-items-center">
              <span class="text-center info-status">Início</span>
              <span class="text-center tit-principal" *ngIf="!modoEdicaoOdometro; else inputNovoOdometroInicio">{{kmOdometroInicio}} Km | {{dataInicialOdometro}}</span>
              <ng-template #inputNovoOdometroInicio>
                <div style="width: 130px;" class="m-2 d-flex align-items-end">
                    <input type="number" class="form-control me-1" [(ngModel)]="kmOdometroInicioEdit">Km
                </div>
               
              </ng-template>
              
              <img class="img-odometro" width="250px" [src]="fotoOdoInicial" alt="Foto Inicial do Odômetro">
            </div>
            <div class="d-flex flex-column align-items-center">
              <span class="text-center info-status">Final</span>
              <span class="text-center tit-principal" *ngIf="!modoEdicaoOdometro; else inputNovoOdometroFinal" >{{kmOdometroFinal != null? kmOdometroFinal : '---'}} Km | {{ kmOdometroFinal != null? dataFinalOdometro : '--/--/---- --:--'}}</span>
                
              <ng-template #inputNovoOdometroFinal>
                <div style="width: 130px;" class="m-2 d-flex align-items-end" >
                  <input type="number" class="form-control me-1" [(ngModel)]="kmOdometroFinalEdit">Km
                </div>
              </ng-template>
              <img class="img-odometro" *ngIf="kmOdometroFinal != null;else semOdomFinal" width="250px" [src]="fotoOdoFinal" alt="Foto Final do Odômetro" >
              <ng-template #semOdomFinal>
                <div class="sem-odometro">
                  <span>Odômetro final não enviado até o momento</span>
                </div>
              </ng-template>              
            </div>
          </div>
          <div class="mt-2 d-flex justify-content-between align-items-baseline">

            <app-texto-link titulo="Editar odômetro" icone='icon-lapis-green' class="ms-4" *ngIf="!modoEdicaoOdometro; else btnCancelar" (click)="alteraModoEditoOdometro(true)"></app-texto-link>
            <ng-template #btnCancelar>
                <app-texto-link titulo="Cancelar" icone='close' class="ms-4"  (click)="alteraModoEditoOdometro()"></app-texto-link>
            </ng-template>         
          
            <app-botao-primario *ngIf="!modoEdicaoOdometro; else btnSalvarOdometro"
              titulo="Baixar fotos de odômetros"
              (onPress)="downloadFotosOdometros()"
              imagemBtn="assets/img/icons/download_comprovante_dark.svg"
              title="Download odometros"
              [disabled]="loadingBtnDownloadOdometro">
            </app-botao-primario>

            <ng-template #btnSalvarOdometro>
              <app-botao-primario 
                titulo="Salvar"
                (onPress)="salvaOdometro()"
                imagemBtn="assets/img/icons/icon-status-finalizado-green.svg"
                title="Salvar">
              </app-botao-primario>
            </ng-template>       
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
